<template>
  <div class="animated fadeIn">
      <b-row>
        <b-col xs="12" lg="12">
          <b-card>
            <div slot="header">
              Donation
            </div>
            <donation-form :donation="donation"></donation-form>
          </b-card>
        </b-col>
      </b-row>
  </div>
</template>

<script>

   import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
   import {Donation} from "../../models/Donation";
   import DonationForm from "../../components/donation/DonationForm";

   export default {
    name: 'donation',
    components: {
      DonationForm,
    },
    data() {
        return {
            donation: new Donation(),
            donationId: this.$route.params.donationId,
        }
    },
    mounted() {
      RepositoryFactory
        .get('donation')
        .getDonation(this.donationId)
        .then(
          response => (
            this.donation = new Donation(response.data.data)
          )
        )
    }
   }
</script>
